import { createAsyncThunk } from '@reduxjs/toolkit';

export const getSavedSalesChannelMapping = createAsyncThunk(
  'salesChannels/getSavedSalesChannelMapping',
  async ({ salesChannelId }, { extra: { sdk, Logger } }) => {
    try {
      const { data } = await sdk.setup.getSavedSalesChannelMapping(salesChannelId);
      return data;
    } catch (error) {
      Logger.error(
        new Error('Get saved sales channel mapping failed'),
        { error, salesChannelId },
        ['ConnectShopifyChGetSavedMappingFailed', { salesChannelId: salesChannelId ? String(salesChannelId) : '' }],
      );
      throw error;
    }
  },
);
